import React from "react";




const PageTitle = ({section, currentPage}) => {

    return(
   <div className="page_title">
       <div className="section_container">
           {/* <div className='side_nav_icon_container'> */}
              <img src = {section.icon}/>
            {/* </div> */}
            <h1>{section.title}</h1>
       </div>
       <div className="page_indicator">
       {section.pages.map((page,index) => <div className={index < currentPage ?'filled':'empty'}></div>)}

       </div>
   </div>
    )
}
export default PageTitle